import { format, isDate, isBefore, startOfWeek, addDays } from 'date-fns';

export interface LabelValue {
    label: string;
    value: string | number | boolean | null;
}

export class CalendarDay {
    day: Date;
    dayOfMonth: string;
    isPeriodFrom = false;
    isPeriodTo = false;
    isInPeriod = false;
    isToday = false;
    isThisYear = false;
    isThisMonth = false;
    isSelectedDay = false;
    isoDate: string;

    public constructor(date: Date, displayMonth: Date, day?: Date,  dayTo?: Date) {
        const today = new Date();

        this.day = date;
        this.dayOfMonth = format(this.day, 'dd');
        this.isToday = isSameDate(this.day, today);
        this.isThisYear = this.day.getFullYear() == today.getFullYear();
        this.isoDate = format(this.day, 'yyyy-MM-dd');

        if (day != null) {
            this.isSelectedDay =  isSameDate(this.day, day);
            this.isThisMonth = this.day.getFullYear() == displayMonth.getFullYear() && this.day.getMonth() == displayMonth.getMonth();
            this.isPeriodFrom = isSameDate(this.day, day);
        }
        if (day != null && dayTo != null && isBefore(day, dayTo)) {
            this.isPeriodTo = isSameDate(this.day, dayTo);
            this.isInPeriod = isBefore(day, this.day) && isBefore(this.day, dayTo);
        }
    }
}

function isSameDate(date1: Date, date2: Date) {
    return isDate(date1) && isDate(date2)
        && date1.getDate() == date2.getDate()
        && date1.getMonth() == date2.getMonth()
        && date1.getFullYear() == date2.getFullYear();
}
